export default function ModuleContainer({ title, subtitle, children }) {
  return (
    <div className="bg-korinth-surface border border-korinth-border rounded-lg">
      {(title || subtitle) && (
        <div className="px-4 py-3 border-b border-korinth-border">
          {title && <h2 className="text-sm font-semibold text-white">{title}</h2>}
          {subtitle && <p className="text-xs text-korinth-muted mt-0.5">{subtitle}</p>}
        </div>
      )}
      <div className="p-4">{children}</div>
    </div>
  );
}
